import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import styles from "./App.module.css";
import TodoInput from "./TodoInput";
import TodoList from "./TodoList";
// import todoData from "./data";
function App() {
  const [todos, setTodos] = useState(() => {
    const saved = localStorage.getItem("todos");
    return saved
      ? JSON.parse(saved)
      : [
          {
            id: uuidv4(),
            text: "Learn React",
            completed: true,
            priority: "low",
          },
          {
            id: uuidv4(),
            text: "Build a Todo App",
            completed: false,
            priority: "low",
          },
        ];
  });
  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);
  const onAddTodo = (text) => {
    const newItem = {
      id: uuidv4(),
      text: text,
      completed: false,
      priority: "low",
    };
    setTodos((prevTodos) => [...prevTodos, newItem]);
  };
  const handleComplete = (id) => {
    setTodos(
      todos.map((todo) =>
        todo.id === id ? { ...todo, completed: !todo.completed } : todo
      )
    );
  };
  const deleteTodo = (id) => {
    const updatedTodos = todos.filter((todo) => todo.id !== id);
    setTodos(updatedTodos);
  };
  return (
    <div className={styles.appContainer}>
      <div className={styles.todoCard}>
        <h2 className={styles.heading}>Tasks</h2>
        <p className={styles.subheading}>
          Keep track of your tasks and stay organized
        </p>
        <TodoInput onAddTodo={onAddTodo}></TodoInput>
        <TodoList
          todos={todos}
          deleteTodo={deleteTodo}
          handleComplete={handleComplete}
        ></TodoList>
      </div>
    </div>
  );
}

export default App;
